export default __webpack_public_path__ + "static/media/truck_3_3.5400a97d.svg";